module.exports = __webpack_public_path__ + "static/media/lunLogo.d9e0ba91.svg";